module.exports = __webpack_public_path__ + "img/banner-1-m.5f09c618.jpg";